import { useQuery } from 'react-query';
import useMerchant from './useMerchant';
import { useSnackbar } from 'notistack';

// ----------------------------------------------------------------------

interface Params {
  key: string;
  fetchFunction: any;
  params: {
    programmeCode?: string;
    merchantCode?: string;
  };
}

const useReportData = ({ key, fetchFunction, params }: Params, enabled?: boolean) => {
  const { merchant } = useMerchant();
  const { enqueueSnackbar } = useSnackbar();
  const queryKey = [key, params];

  return useQuery(queryKey, () => fetchFunction(params), {
    staleTime: 30000, // Data considered fresh for 30 seconds
    refetchOnWindowFocus: false, // Don't refetch data when window gains focus
    enabled: !!merchant?.code && enabled,
    onError: (error) => {
      console.error('query key - error:', key, error);
      enqueueSnackbar('Ops! Something went wrong!', { variant: 'error' });
    },
  });
};

export default useReportData;
